import React from "react";
// css
import "./FellowSailorCard.css";
// assets
import star from "assets/Images/icons/star.svg";

// Home page Fellow Slider Card
const FellowSellerCard = (props) => {
  return (
    <>
      <div className="fellow_seller_card">
        <img src={props.topImg} alt="..." />
        <div className="fsc_top">
          <img src={star} alt="star" />
          <img src={star} alt="star" />
          <img src={star} alt="star" />
          <img src={star} alt="star" />
          <img src={star} alt="star" />
        </div>
        <div className="fsc_title">
          <strong>{props.name}</strong>
          <span>{props.date}</span>
        </div>
        <div className="fsc_text">
          <h2>{props.title}</h2>
        </div>
        <div className="fsc_para">
          <p>{props.detail}</p>
        </div>
      </div>
    </>
  );
};

export default FellowSellerCard;
